const personalData = {
  img: "/Img/main-sec2.jpg",
  title: "Andre Faassen",
  description: (
    <>
      Ich habe mich auf den Beruf des Mediengestalters Bild/Ton spezialisiert.{" "}
      <br />
      In diesem Bereich kann ich meiner Kreativität freien lauf lassen und meine
      Ideen umsetzen, allerdings möchte ich Ihre Ideen hören und zusammen
      kreieren wir ein geniales Endprodukt. <br />
      <br />
      Ich freue mich auf Ihre Nachricht!
    </>
  ),
  preview: `Ich habe mich auf den Beruf des Mediengestalters Bild/Ton spezialisiert. In diesem Bereich kann ich meiner Kreativität 
    freien Lauf zu lassen und meine..`,
};

export default personalData;
